import React from 'react';

const NotFound = () => {
    return (
        <div>
            Nothing to see here..
        </div>
    );
}

export default NotFound;